import { Calendar, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

interface PriceOnRequestCardProps {
  variant?: 'compact' | 'default' | 'expanded';
  onRequestClick: () => void;
  className?: string;
}

export const PriceOnRequestCard = ({ 
  variant = 'default', 
  onRequestClick,
  className = ''
}: PriceOnRequestCardProps) => {
  if (variant === 'compact') {
    return (
      <div className={`space-y-2 ${className}`}>
        <div className="flex items-center gap-2 text-brand-teal">
          <Sparkles className="w-4 h-4" />
          <span className="font-semibold">Price on Request</span>
        </div>
        <p className="text-sm text-muted-foreground">
          Contact us for exclusive pricing and offers
        </p>
      </div>
    );
  }

  if (variant === 'expanded') {
    return (
      <Card className={`border-brand-teal/30 bg-gradient-to-br from-brand-teal/5 to-transparent ${className}`}>
        <CardContent className="p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-brand-teal/20 flex items-center justify-center">
              <Sparkles className="w-6 h-6 text-brand-teal" />
            </div>
            <div>
              <h3 className="font-display text-xl font-bold text-brand-teal">
                Exclusive Pricing Available
              </h3>
              <p className="text-sm text-muted-foreground">
                Tailored to your investment needs
              </p>
            </div>
          </div>

          <div className="space-y-2 text-sm text-muted-foreground">
            <p className="flex items-start gap-2">
              <span className="text-brand-teal mt-1">✓</span>
              <span>Flexible payment plans available</span>
            </p>
            <p className="flex items-start gap-2">
              <span className="text-brand-teal mt-1">✓</span>
              <span>Customization options included</span>
            </p>
            <p className="flex items-start gap-2">
              <span className="text-brand-teal mt-1">✓</span>
              <span>Special launch offers for early investors</span>
            </p>
          </div>

          <Button 
            size="lg" 
            className="w-full bg-brand-teal hover:bg-brand-navy text-white"
            onClick={onRequestClick}
          >
            <Calendar className="w-5 h-5 mr-2" />
            Request Pricing Information
          </Button>

          <p className="text-xs text-center text-muted-foreground">
            Our team responds within 4 hours
          </p>
        </CardContent>
      </Card>
    );
  }

  // Default variant
  return (
    <Card className={`border-brand-teal/30 bg-gradient-to-br from-brand-teal/5 to-transparent ${className}`}>
      <CardContent className="p-6 space-y-4">
        <div className="flex items-center gap-2 text-brand-teal">
          <Sparkles className="w-5 h-5" />
          <h3 className="font-semibold text-lg">Exclusive Pricing Available</h3>
        </div>
        <p className="text-muted-foreground">
          Contact our team for personalized pricing, flexible payment options, and special launch offers.
        </p>
        <Button 
          size="lg" 
          className="w-full bg-brand-teal hover:bg-brand-navy text-white"
          onClick={onRequestClick}
        >
          <Calendar className="w-5 h-5 mr-2" />
          Request Pricing Information
        </Button>
      </CardContent>
    </Card>
  );
};
